import { CommonFnCallMessage } from "../../types";
import { EventBody, MessageComponent, MessageComponentProps } from "./Message";
import FunctionCall from "../../chalk/FunctionCall";
import { isServiceInteraction } from "../../util/momentEventItem";
import { useAgentViewPreferences } from "../../agent/viewPreferences/agentViewPreferences";

const FnCallMessage: MessageComponent<CommonFnCallMessage> = ({
  message,
  moment,
  textFilter,
}: MessageComponentProps<CommonFnCallMessage>) => {
  const functionCall = message.function_call;
  const cue = moment?.event_wrappers.find(isServiceInteraction)?.event.cue;

  const { showCompactStateContent } = useAgentViewPreferences();

  return (
    <>
      {!!cue && (
        <div>
          <EventBody>{`Cue: ${cue}`}</EventBody>
        </div>
      )}
      <FunctionCall
        selectedFn={functionCall}
        textHighlight={textFilter}
        showMessageWhitespace={!showCompactStateContent}
      />
    </>
  );
};

export default FnCallMessage;
